/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../../app/cart/properties/cart.properties.component';
const styles_CartPropertiesComponent:any[] = ([] as any[]);
export const RenderType_CartPropertiesComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_CartPropertiesComponent,data:{}});
function View_CartPropertiesComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),0,'li',[['class',
      'extra-field-value']],[[8,'innerHTML',1]],(null as any),(null as any),(null as any),
      (null as any)))],(null as any),(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,0,0,currVal_0);
  });
}
function View_CartPropertiesComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),4,'ul',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['\n            '])),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CartPropertiesComponent_2)),
      i0.ɵdid(3,802816,(null as any),0,i1.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,
          i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵted(-1,
          (null as any),['\n        ']))],(_ck,_v) => {
    const currVal_1:any = _v.context.$implicit.values;
    _ck(_v,3,0,currVal_1);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵinlineInterpolate(1,'',_v.context.$implicit.slug,'');
    _ck(_v,0,0,currVal_0);
  });
}
export function View_CartPropertiesComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),7,'div',[['class',
      'append cart-extra-fields d-none']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i0.ɵeld(2,0,(null as any),(null as any),4,'div',[['class','extra-fields-details']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CartPropertiesComponent_1)),i0.ɵdid(5,
          802816,(null as any),0,i1.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i0.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i2.CartPropertiesComponent = _v.component;
    const currVal_0:any = _co.prepareExtraFields();
    _ck(_v,5,0,currVal_0);
  },(null as any));
}
export function View_CartPropertiesComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'cart-properties',
      ([] as any[]),(null as any),(null as any),(null as any),View_CartPropertiesComponent_0,
      RenderType_CartPropertiesComponent)),i0.ɵdid(1,49152,(null as any),0,i2.CartPropertiesComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const CartPropertiesComponentNgFactory:i0.ComponentFactory<i2.CartPropertiesComponent> = i0.ɵccf('cart-properties',
    i2.CartPropertiesComponent,View_CartPropertiesComponent_Host_0,{extraFields:'extraFields'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjMjY0NTc5MDQ3Mi9zcmMvc3JjL2FwcC9jYXJ0L3Byb3BlcnRpZXMvY2FydC5wcm9wZXJ0aWVzLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9jb2RlYnVpbGQvb3V0cHV0L3NyYzI2NDU3OTA0NzIvc3JjL3NyYy9hcHAvY2FydC9wcm9wZXJ0aWVzL2NhcnQucHJvcGVydGllcy5jb21wb25lbnQudHMiLCJuZzovLy9jb2RlYnVpbGQvb3V0cHV0L3NyYzI2NDU3OTA0NzIvc3JjL3NyYy9hcHAvY2FydC9wcm9wZXJ0aWVzL2NhcnQucHJvcGVydGllcy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMjY0NTc5MDQ3Mi9zcmMvc3JjL2FwcC9jYXJ0L3Byb3BlcnRpZXMvY2FydC5wcm9wZXJ0aWVzLmNvbXBvbmVudC50cy5DYXJ0UHJvcGVydGllc0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJhcHBlbmQgY2FydC1leHRyYS1maWVsZHMgZC1ub25lXCI+XG4gICAgPGRpdiBjbGFzcz1cImV4dHJhLWZpZWxkcy1kZXRhaWxzXCI+XG4gICAgICAgIDx1bCAqbmdGb3I9XCJsZXQgZXh0cmFGaWVsZCBvZiBwcmVwYXJlRXh0cmFGaWVsZHMoKVwiIGNsYXNzPVwie3tleHRyYUZpZWxkLnNsdWd9fVwiPlxuICAgICAgICAgICAgPGxpIGNsYXNzPVwiZXh0cmEtZmllbGQtdmFsdWVcIlxuICAgICAgICAgICAgICAgICpuZ0Zvcj1cImxldCB2YWx1ZSBvZiBleHRyYUZpZWxkLnZhbHVlc1wiXG4gICAgICAgICAgICAgICAgW2lubmVySFRNTF09XCJ2YWx1ZVwiPjwvbGk+XG4gICAgICAgIDwvdWw+XG4gICAgPC9kaXY+XG48L2Rpdj4iLCI8Y2FydC1wcm9wZXJ0aWVzPjwvY2FydC1wcm9wZXJ0aWVzPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztvQkNHWTtNQUFBO01BQUE7SUFFSTtJQUZKLFdBRUksU0FGSjs7OztvQkFESjtNQUFBO01BQWdGLHNEQUM1RTtVQUFBO2FBQUE7NEJBQUEseUNBRTZCO1VBQUE7SUFEekI7SUFESixXQUNJLFNBREo7O0lBRGdEO0lBQXBELFdBQW9ELFNBQXBEOzs7O29CQUZSO01BQUE7TUFBQSw4QkFBNkM7TUFDekM7VUFBQTtNQUFrQyxrREFDOUI7VUFBQSxzRUFBQTtVQUFBO1VBQUEsdUNBSUs7VUFBQSxhQUNIOztJQUxFO0lBQUosV0FBSSxTQUFKOzs7O29CQ0ZSO01BQUE7d0NBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/$$_gendir/app/cart/properties/cart.properties.component.ngfactory.ts